import { useCallback, useState } from 'react';
import useOnMount from './useOnMount';
import useListenWindowEvent from './useListenWindowEvent';

const useScreen = (delay?: number) => {
  const [screen, setScreen] = useState({
    isDesktop: false,
    isTablet: false,
    isMobile: false,
  });

  const listener = useCallback(() => {
    const width = window.innerWidth;
    setScreen({
      isDesktop: width >= 1024,
      isTablet: width >= 768 && width < 1024,
      isMobile: width < 768,
    });
  }, []);

  useOnMount(listener);
  useListenWindowEvent('resize', listener, delay);
  return screen;
};

export default useScreen;
